/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Invalid_TitleInputs */

const en_invite_invalid_title = /** @type {(inputs: Invite_Invalid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite not valid`)
};

const de_invite_invalid_title = /** @type {(inputs: Invite_Invalid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladung ungültig`)
};

/**
* | output |
* | --- |
* | "Invite not valid" |
*
* @param {Invite_Invalid_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const invite_invalid_title = /** @type {((inputs?: Invite_Invalid_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Invalid_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_invite_invalid_title(inputs)
	return en_invite_invalid_title(inputs)
});